import { em } from 'polished'
import styled from 'styled-components'

import { H2, TextUpper } from 'styles/components/typography'

export const Wrapper = styled.div`
  position: absolute;
  background-color: ${p => p.theme.colors.lilac};
  width: calc(100% - ${p => p.theme.indents.baseIndentXs});
  max-width: ${em(440)};
  padding-left: ${p => p.theme.indents.baseIndentXs};
  margin-left: -${p => p.theme.indents.baseIndentXs};
  margin-top: ${em(65)};
  padding-top: ${em(20)};

  ${p => p.theme.mq.upMd} {
    // 60%                          - width of address block
    // baseIndentMd                 - base indents of wrapper at the each side
    // 60% + baseIndentMd           - width with padding
    width: calc(60% + ${p => p.theme.indents.baseIndentMd});
    max-width: none;
    padding: ${em(40)} ${p => p.theme.indents.baseIndentMd};
    margin-left: -${p => p.theme.indents.baseIndentMd};
  }

  ${p => p.theme.mq.upLg} {
    // 50%                          - width of address block
    // baseBoxIndentLg              - base indents of wrapper at the each side
    // 50% + baseBoxIndentLg        - width with padding
    width: calc(50% + ${p => p.theme.indents.baseBoxIndentLg});
    padding: ${em(60)} ${p => p.theme.indents.baseBoxIndentLg};
    margin-left: -${p => p.theme.indents.baseBoxIndentLg};
  }
`

export const TextUpperStyled = styled(TextUpper)`
  color: ${p => p.theme.colors.whiteOp6};
  display: none;

  ${p => p.theme.mq.upMd} {
    display: block;
  }
`

export const TextBox = styled.div`
  margin-bottom: ${em(40)};

  ${p => p.theme.mq.upMd} {
    margin-bottom: ${em(20)};
  }
`

export const H2Styled = styled(H2)`
  color: ${p => p.theme.colors.white};
`

export const TitleBox = styled.div`
  margin-bottom: ${em(40)};

  ${p => p.theme.mq.upMd} {
    margin-bottom: ${em(75)};
  }
`
